import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, { FC } from 'react';

import { RootState, useSelector } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    multi_image: [
      'shop now - image1',
      'shop now - image2',
      'shop now - image3'
    ],
    multi_left_button: [
      'never show - button1',
      'never show - button2',
      'never show - button3'
    ],
    multi_right_button: [
      'close - button1',
      'close - button2',
      'close - button3'
    ]
  }
};

const SlideModalRoundTracking: FC = () => {
  const currentIndex = useSelector(
    (state: any) => state.imageUpload.currentIndex
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const modalLeftUrl = 'https://i.ibb.co/xL684x8/modal-left.png';
  const modalRightUrl = 'https://i.ibb.co/89XNkSx/modal-right.png';

  const style = `
.root_tracking {
    width: 100%;
    height: 100%;

    overflow: hidden;
    position: relative;
    background: none;
    
    .modal_wrapper {
        min-height: 488px;
        width: 100%;
  
        display: flex;
        flex-direction: column;
  
        position: absolute;
        top: 50%;
        transform: translate(0%, -50%);
    }

    .contents_wrapper {
      padding: 0 1rem;
      margin: 2rem 0 1rem 0;
      height: 6.5rem;
    }
    .contents_box {
      height: 6.5rem;
    }
    .contents_box .title {
      width: 100%;
      height: 2rem;
      margin-bottom: 0.5rem;

      display: flex;
      align-items: center;
    }
    .contents_box .sub_title {
      width: 100%;
      height: 4rem;

      display: flex;
      align-items: center;
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list,
    .slick_wrapper .slick-track div,
    .slick_wrapper .slick-track img {
      width: 100%;
      min-height: 288px;
      outline: none;
    }
    .slick_wrapper .slick-list {
      overflow: hidden;
    }
    .slick_wrapper .slick-track {
      display: flex;
    }
    .slick_wrapper .slick-track img {
      object-fit: cover;
    }

    .slick-prev {
      width: 1.5rem;
      height: 3rem;

      z-index: 999;
      left: 0;
      background-image: url(${modalLeftUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }
    .slick-prev:before {
      display: none;
      background-image: url(${modalLeftUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }
    .slick-prev:hover {
      opacity: 1;
      display: block;
      background-image: url(${modalLeftUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }
    .slick-next {
      width: 1.5rem;
      height: 3rem;

      z-index: 999;
      right: 0;
      background-image: url(${modalRightUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }
    .slick-next:before {
      display: none;
      background-image: url(${modalRightUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }
    .slick-next:hover {
      opacity: 1;
      display: block;
      background-image: url(${modalRightUrl});
      background-repeat: no-repeat;
      background-size: cover;
    }

    .btn_wrapper {
      height: 2.5rem;
    }
    .btn_wrapper button {
      border: 0;
      background-color: transparent;
    }
    .btn_wrapper .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .btn_wrapper .style02 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
    }
}
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <>
        <div className="root_tracking">
          <div className="modal_wrapper">
            <div className="contents_wrapper" />
            <div className="slick_wrapper tracking_center">
              <EditTracking
                value={tracking?.multi_image?.[currentIndex]}
                type="multi_image"
              />
            </div>
            <div className="btn_wrapper tracking_center">
              <EditTracking
                value={tracking?.multi_left_button?.[currentIndex]}
                type="multi_left_button"
              />
            </div>
            <div className="btn_wrapper tracking_center">
              <EditTracking
                value={tracking?.multi_right_button?.[currentIndex]}
                type="multi_right_button"
              />
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default SlideModalRoundTracking;
